import React, { useState } from "react"
import { Box, Grid, IconButton, Menu, MenuItem } from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import PropTypes from "prop-types"
import i18n from "i18n"
import ContactCard from "./ContactCard"

const ContactsCards = ({ contacts, onEditContact, onDeleteContact }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedContact, setSelectedContact] = useState(null)

  const handleMenuOpen = (event, contact) => {
    setAnchorEl(event.currentTarget)
    setSelectedContact(contact)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    setSelectedContact(null)
  }

  const handleEdit = () => {
    if (onEditContact && selectedContact) onEditContact(selectedContact)
    handleMenuClose()
  }

  const handleDelete = () => {
    if (onDeleteContact && selectedContact) onDeleteContact(selectedContact)
    handleMenuClose()
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={3}>
        {contacts?.map(contact => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={contact.SK}>
            <Box
              sx={{ position: "relative" }}
              onClick={() => onEditContact(contact)}
            >
              <ContactCard contact={contact} />
              <IconButton
                aria-label={i18n.t("contacts.moreOptions")}
                onClick={e => e.stopPropagation() || handleMenuOpen(e, contact)}
                sx={{ position: "absolute", top: 8, right: 8, zIndex: 2 }}
              >
                <MoreVertIcon />
              </IconButton>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleEdit}>{i18n.t("contacts.edit")}</MenuItem>
        <MenuItem onClick={handleDelete}>{i18n.t("contacts.delete")}</MenuItem>
      </Menu>
    </Box>
  )
}

ContactsCards.propTypes = {
  contacts: PropTypes.array,
  onEditContact: PropTypes.func,
  onDeleteContact: PropTypes.func,
}

ContactsCards.defaultProps = {
  contacts: [],
  onEditContact: () => {},
  onDeleteContact: () => {},
}

export default ContactsCards
